<template>
    <div class="background">
        <div class="header">
            <div class="title-container">
                <h3>Paramètres</h3>
            </div>
        </div>
        <div class="body">
            <b-button variant="default" v-b-toggle="'dashboard_settings'" block class="d-flex">
                <span>Tableau de bord</span>
                <strong v-if="collapse1_isVisible" aria-hidden="true" class="ml-auto">-</strong>
                <strong v-else aria-hidden="true" class="ml-auto">+</strong>
            </b-button>
            <br>
            <b-collapse class="dashboard_settings_collapse" id="dashboard_settings" v-model="collapse1_isVisible">
                <b-card class="dashboard_settings_card">
                    <b-row>
                        <b-col><p>Nombre de pointages affichés :</p></b-col>
                        <b-col><b-form-select class="displayed_pointages_select" v-model="displayed_pointages" :options="displayed_pointages_options" @change="updateDisplayedPointages"></b-form-select></b-col>
                        <b-col></b-col>
                        <b-col></b-col>
                    </b-row>
                </b-card>
            </b-collapse>
            <b-button variant="default" v-b-toggle="'employee_details_settings'" block class="d-flex">
                <span>Détails employés</span>
                <strong v-if="collapse2_isVisible" aria-hidden="true" class="ml-auto">-</strong>
                <strong v-else aria-hidden="true" class="ml-auto">+</strong>
            </b-button>
            <br>
            <b-collapse class="employee_details_settings_collapse" id="employee_details_settings" v-model="collapse2_isVisible">
                <b-card class="employee_details_settings_card">
                    <b-row>
                        <b-col><p>Nombre de pointages affichés dans la prévisualisation de l'historique :</p></b-col>
                        <b-col><b-form-select class="displayed_pointages_hostory_select" v-model="displayed_pointages_history" :options="displayed_pointages_history_options" @change="updateDisplayedPointagesHistory"></b-form-select></b-col>
                        <b-col></b-col>
                        <b-col></b-col>
                    </b-row>
                </b-card>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import conf from '../../../config/api'
import config from '../../../config/config'

export default {
    data() {
        return {
            collapse1_isVisible: false,
            displayed_pointages: config.nbPointageEventDisplayed,
            displayed_pointages_option_selected: config.nbPointageEventDisplayed,
            displayed_pointages_options: [
                {value:1, text: '1'},
                {value:2, text: '2'},
                {value:3, text: '3'},
                {value:4, text: '4'},
                {value:5, text: '5'},
                {value:6, text: '6'},
                {value:7, text: '7'},
                {value:8, text: '8'},
                {value:9, text: '9'},
                {value:10, text: '10'},
            ],
            collapse2_isVisible: false,
            displayed_pointages_history: config.nbPointageHistoryDisplayed,
            displayed_pointages_history_option_selected: config.nbPointageHistoryDisplayed,
            displayed_pointages_history_options: [
                {value:1, text: '1'},
                {value:2, text: '2'},
                {value:3, text: '3'},
                {value:4, text: '4'},
                {value:5, text: '5'},
                {value:6, text: '6'},
                {value:7, text: '7'},
                {value:8, text: '8'},
                {value:9, text: '9'},
                {value:10, text: '10'},
            ],
        }
    },

    mounted() {
        //this.renderChart();
    },
    computed: {
        
    },

    async created() {
        
    },
    methods: {
        async updateDisplayedPointages(){
            localStorage.setItem('displayed_pointages', this.displayed_pointages);
        },

        async updateDisplayedPointagesHistory(){
            localStorage.setItem('nbPointageHistoryDisplayed', this.displayed_pointages_history);
        }
    }
}
</script>

<style scoped>
.background {
    background-color: #323232;
    height: 100%;
}

.header {
    width: 100%;
    height: 60px;
    background-color: #333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.1px solid #bcbcbc;
}
.body{
    background-color: #3f3f3f;
    height: calc(100%-60px);
    padding: 15px;
}
.title-container {
    margin-left: 20px;
}

.title-container h3 {
    color: #fff;
}
span{
    color: #fff;
}
.dashboard_settings_collapse{
    border: none;
}
.dashboard_settings_collapse :focus{
    border: none;
}
.dashboard_settings_card{
    background-color: #3f3f3f;
    color: #fff;
    border: none;
}
.displayed_pointages_select{
    background-color: #4f4f4f;
    color: #fff;
    border: none;
}
.displayed_pointages_select :focus{
    border: none;
}
.employee_details_settings_card{
    background-color: #3f3f3f;
    color: #fff;
    border: none;
}
.displayed_pointages_hostory_select{
    background-color: #4f4f4f;
    color: #fff;
    border: none;
}
</style>